export const CB_BRANDING = "canalblog"
export const OB_BRANDING = "overblog"
export const EB_BRANDING = "eklablog"
